
import React from 'react';
import { FlowRender } from "../flow-render";
import Hyperverge from "../../client/components/Hyperverge";
import {HYPERVERGE_STATE} from "../hyperverge-constants";
import { sprintf } from "sprintf-js";

const TEXT_0 = "We are going to use your cell phone camera to match "
  + "your face to your driver's license.";
const TEXT_1 = "Please make sure your phone browser has your camera setting turned on.";

// convert DD-MM-YYYY to MM/DD/YYYY
const xlate_date = hyp_date => {
  const [ DD, MM, YYYY ] = hyp_date.split("-");
  return sprintf("%s/%s/%s", MM, DD, YYYY);
}

class KYC extends FlowRender {
  constructor(index) {
    super(index, []);
  }

  renderBody = component => {
    const onboarding = component.getOnboardingData();
    const state = onboarding.hyperverge.state;
    const text_style = {
      fontSize: "1.2rem",
      fontWeight: "bold",
    }
    if (state === HYPERVERGE_STATE.INIT) {
      return (
        <div>
          <div style={text_style}>
            { TEXT_0 }
          </div>
          <div style={{height: "1rem"}}/>
          <div style={text_style}>
            { TEXT_1 }
          </div>
          <Hyperverge
            onboardingComponent={component}
            onSave={this.onKYCSaved(component)}
          />
        </div>
      )
    }
  }

  onKYCSaved = (component) => (user_data, uploaded_files) => {

    const onboarding = component.getOnboardingData();
    onboarding.hyperverge.state = HYPERVERGE_STATE.KYC;
    onboarding.hyperverge.data = user_data;

    const details = user_data.details;
    const first_name = details['First name'] && details['First name'].trim();
    const last_name = details['Last name'] && details['Last name'].trim();
    const new_data = {
      role_0_first_name: first_name,
      role_0_last_name: last_name,
      role_0_dob: xlate_date(details.dateOfBirth),
      //role_0_address: address[0].trim(),
      role_0_city: details.district,
      role_0_state: details.province,
      role_0_zip: details.zipCode,
      docusign_files: uploaded_files,
      hyperverge: {
        ...onboarding.hyperverge,
      }
    }
    if (details.houseNumber && details.street) {
      new_data.role_0_address = details.houseNumber + " " + details.street;
    }

    component.props.dataToStore(new_data, component.getOnboardingIndex());
    component.props.dataToDynamo(
      new_data,
      component.getOnboardingIndex(), () => {
        const url = component.getRootUrl() + "/personal_info";
        component.onNavigate(url);
      }, true);

  }

  render = component => {

    const width = "60%";
    const title = "Welcome";
    const VIMEO_ID = "852505145";
    const header_style = {
      marginRight: "1rem",
      transform: "translate(0, -0.6rem)",
      fontWeight: "bold",
    }
    const header_div = (
      <div style={header_style}>
        <div>Introduction video</div>
        <div align={"right"}>29 seconds</div>
      </div>
    )
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, title, width, VIMEO_ID, header_div)}
        { this.renderProgress(component, width)}
        { this.renderSingleColumn(
          this.renderBody(component), width) }
      </div>
    )
  }
}

export { KYC };
